import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../firebaseConfig';
import { ref, get } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';

const SubscriptionGuard = ({ children }) => {
    const [status, setStatus] = useState('loading'); // loading, allowed, expired, no-auth, not-verified

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) {
                setStatus('no-auth');
                return;
            }

            // 1. Mail Doğrulama Kontrolü (Ekstra Güvenlik)
            if (!user.emailVerified) {
                setStatus('not-verified');
                return;
            }

            // 2. Veritabanı Süre Kontrolü
            const userRef = ref(db, `users/${user.uid}`);
            try {
                const snapshot = await get(userRef);
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    const expiryDateStr = data.subscription_expiry;
                    
                    if (!expiryDateStr) {
                        setStatus('expired'); 
                        return;
                    }

                    const expiryDate = new Date(expiryDateStr);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    if (today <= expiryDate) {
                        setStatus('allowed');
                    } else {
                        setStatus('expired');
                    }
                } else {
                    setStatus('expired');
                }
            } catch (error) {
                console.error("DB Error:", error);
                setStatus('expired');
            }
        });

        return () => unsubscribe();
    }, []);

    if (status === 'loading') return <div style={{textAlign:'center', marginTop:'50px'}}>Yetki kontrolü...</div>;
    
    // Giriş yapmamışsa Login'e
    if (status === 'no-auth') return <Navigate to="/login" replace />;

    // Mail doğrulamamışsa Login'e (veya özel bir uyarı sayfasına)
    if (status === 'not-verified') {
        alert("E-posta adresinizi doğrulamanız gerekmektedir.");
        return <Navigate to="/login" replace />;
    }

    // Süresi bitmişse Profile'e
    if (status === 'expired') {
        return <Navigate to="/profile" replace />;
    }

    // Her şey yolundaysa sayfayı göster
    return children;
};

export default SubscriptionGuard;